import React from 'react';
import PropTypes from 'prop-types';
import PublicReportGraph from '../PublicReportGraph/PublicReportGraph';

function PublicReportPage(props) {
  const { publicReportHashKey } = props;
  const params = new URLSearchParams(window.location.search);
  const tempScale = params.get('tempScale');
  const timeZone = params.get('timezone');
  const airSpeedScale = params.get('airSpeedScale');
  return (
    <div className="col-8 mx-auto">
      <PublicReportGraph
        publicReportHashKey={publicReportHashKey}
        tempScale={tempScale || undefined}
        timeZone={timeZone || undefined}
        airSpeedScale={airSpeedScale || undefined}
      />
    </div>
  );
}

PublicReportPage.propTypes = {
  publicReportHashKey: PropTypes.string.isRequired,
};
export default PublicReportPage;
